import styled from 'styled-components';
import { Colors } from '~/config/Colors';
import Card from '~/pages/Sistema/componentes/Card';
import { Scrollbars } from 'react-custom-scrollbars';

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  height: calc(100% - 8.5em);

  .content-os {
    width: 100%;

    .fechamento {
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
      border-radius: 1em 1em 0 0;
      margin-bottom: 1em;

      .fec-analista {
        width: 95%;
        background: ${Colors.Color23};
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        padding: 1em 1em;
        border-radius: 0 0 1em 1em;
      }
    }
  }
`;

export const ThisCard = styled.div`
  cursor: pointer;
  padding: 0.8em 1.2em;
  border-radius: 1em;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 100%;
  min-height: 5.2em;
  position: relative;
  overflow: hidden;
  box-shadow: ${localStorage.getItem("tema") == "E" ? "0px 0px 19px 0px rgb(4 4 4 / 25%)" : "0px 0px 20px rgba(0,0,0,0.07)"} !important;
  background: ${Colors.Color26};

  .top {
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    .content-top {
      display: flex;
      flex-direction: column;

      .card-cod {
        background: ${Colors.Color2};
        border-radius: 0.4em;
        padding: 0.2em 0.6em;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        width: 4em;

        .cod {
          font-size: 0.7em;
          font-weight: bold;
          color: ${Colors.Color4};
        }
      }

      .card-top {
        margin-top: 0.5em;
        line-height: 0.9em;

        .titulo {
          font-size: 0.7em;
          font-weight: bold;
          color: ${Colors.Color4};
        }

        .analista {
          font-size: 0.6em;
          font-weight: 600;
          color: ${Colors.Color14};
        }
      }
    }

    .info {
      display: flex;
      flex-direction: column;
      align-items: flex-end;

      .data {
        font-size: 0.65em;
        font-weight: 600;
        color: ${Colors.Color14};
      }

      .projeto {
        font-size: 0.65em;
        font-weight: 600;
        color: ${Colors.Color14};
      }

      .cliente {
        font-size: 0.65em;
        font-weight: 600;
        color: ${Colors.Color14};
      }
    }
  }

  .content-os {
    margin-top: 1em;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 100%;

    .right {
      display: flex;

      .acao {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;

        img {
          width: 2.0625em;
        }
      }
    }

    .left {
      display: flex;
      
      .horario {
        display: flex;

        .item-hora {
          display: flex;

          .card-numero {
            border-radius: 0.4em;
            display: flex;
            flex-direction: row;
            width: 1.9em;
            height: 1.9em;
            justify-content: center;
            align-items: center;
          }

          .card-hora {
            border-radius: 0.4em;
            padding: 0.2em 0em;
            display: flex;
            flex-direction: row;
            height: 1.4em;
            margin-right: 1em;
            margin-left: 0.5em;
            justify-content: center;
            align-items: center;

            .hora {
              font-size: 0.7em;
              font-weight: 600;
              color: ${Colors.Color14};
              width: 100%;
            }
          }
        }
      }
    }
  }
`;

export const ThisCardAnalista = styled(Card)`
  cursor: pointer;
  margin-bottom: 1.3em;
  padding: 0.8em 1em;
  border-radius: 1em;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  width: 100%;
  min-height: 5.2em;
  position: relative;
  overflow: hidden;
  box-shadow: ${localStorage.getItem("tema") == "E" ? "0px 0px 19px 0px rgb(4 4 4 / 25%)" : "0px 0px 20px rgba(0,0,0,0.07)"} !important;
  background: ${Colors.Color26};

  .img-perfil {
    display: flex;
    flex-direction: row;
    justify-content: center;
    width: 5em;
    margin-right: 1em;

    img {
      width: 3.6875em;
    }
  }

  .content-perfil {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    width: 100%;
      
    .top {
      display: flex;
      flex-direction: row;
      justify-content: space-between;

      .content-top {
        display: flex;
        flex-direction: column;

        .card-cod {
          background: ${Colors.Color2};
          border-radius: 0.4em;
          padding: 0.2em 0.6em;
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: center;
          width: 4em;

          .cod {
            font-size: 0.7em;
            font-weight: bold;
            color: ${Colors.Color4};
          }
        }

        .card-top {
          margin-top: 0.5em;
          line-height: 0.9em;

          .titulo {
            font-size: 0.7em;
            font-weight: bold;
            color: ${Colors.Color4};
          }

          .analista {
            font-size: 0.6em;
            font-weight: 600;
            color: ${Colors.Color14};
          }
        }
      }

      .info {
        display: flex;
        flex-direction: column;
        align-items: flex-end;

        .data {
          font-size: 0.65em;
          font-weight: 600;
          color: ${Colors.Color14};
        }

        .projeto {
          font-size: 0.65em;
          font-weight: 600;
          color: ${Colors.Color14};
        }

        .cliente {
          font-size: 0.65em;
          font-weight: 600;
          color: ${Colors.Color14};
        }
      }
    }

    .content-os {
      margin-top: 1em;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      width: 100%;

      .right {
        display: flex;
      }

      .left {
        display: flex;
        
        .horario {
          display: flex;

          .item-hora {
            display: flex;

            .card-numero {
              border-radius: 0.4em;
              display: flex;
              flex-direction: row;
              width: 1.9em;
              height: 1.9em;
              justify-content: center;
              align-items: center;
            }

            .card-hora {
              border-radius: 0.4em;
              padding: 0.2em 0em;
              display: flex;
              flex-direction: row;
              height: 1.4em;
              margin-right: 1em;
              margin-left: 0.5em;
              justify-content: center;
              align-items: center;

              .hora {
                font-size: 0.7em;
                font-weight: 600;
                color: ${Colors.Color14};
                width: 100%;
              }
            }
          }
        }
      }
    }
  }
`;

export const ScrollOS = styled(Scrollbars)`
  width: calc(100%) !important;
`;